import { useQuery, useQueryClient } from '@tanstack/react-query';
import { stores } from '../../stores';
import { aiApiCall } from './utils';

export type SmartHelpQueryParams = {
	query: string;
	question: string;
	language?: string;
	sources?: ('relevant' | 'prebid')[];
};

export type SmartHelpQueryResult = {
	key: string;
	text: string;
	followup?: string;
	vote?: -1 | 0 | 1;
};

export const queryKey = (params: SmartHelpQueryParams) => {
	const aiLang = localStorageGet(`aiLang-${stores.identity.userId()}`) ?? 'eng';
	return ['ai', 'help', { ...params, language: aiLang }];
};

export const queryFn = async ({ query, question, language, sources }: SmartHelpQueryParams) => {
	const aiLang = localStorageGet(`aiLang-${stores.identity.userId()}`) ?? 'eng';
	return await aiApiCall('aiHelp', {
		query,
		question,
		language: language ?? aiLang,
		sources,
	}) as SmartHelpQueryResult;
};

export const usePreloadSmartHelp = (params: SmartHelpQueryParams) => {
	const queryClient = useQueryClient();
	return () => {
		queryClient.prefetchQuery({
			queryKey: queryKey(params),
			queryFn: () => queryFn(params),
			staleTime: 1000 * 60,
		});
	};
};

function localStorageGet(key: string) {
	try {
		return JSON.parse(localStorage.getItem(key));
	} catch (e) {
		return null;
	}
}
